import React from "react";
import moment from "moment-timezone";
import { RaisedButton, MenuItem } from "material-ui";

import TicketActions from "../../actions/TicketActions";

import CogButtonMenu from "./cog-button-menu.jsx";

import { capitalize } from "../../util";
import config from "../../config";

class TicketSlide extends React.Component {
  constructor(props) {
    super(props);

    this.cancel = this.cancel.bind(this);
    this.getStyles = this.getStyles.bind(this);
  }

  static contextTypes = {
    isLarge: React.PropTypes.bool,
    tenant: React.PropTypes.object
  };

  cancel() {
    TicketActions.deleteTicket(this.props.ticket.id);
  }

  getStyles() {
    return {
      container: {
        height: "70vw",
        maxHeight: "70vh",
        maxWidth: "70vh",
        margin: "0 auto",
        paddingBottom: "20px",
        display: "flex",
        flexDirection: "column"
      },
      ticket: {
        background: `url(${
          config.endpoint + this.props.ticket.qr_code_path
        }) no-repeat center center`,
        backgroundSize: "contain",
        flex: 1,
        height: "100%",
        width: "100%"
      },
      info: {
        marginTop: 10,
        borderTop: "1px #ccc solid",
        paddingTop: 10,
        lineHeight: 1
      },
      alreadyUsed: {
        position: "absolute",
        fontSize: 20,
        textAlign: "center",
        fontWeight: "bold",
        fontStyle: "italic",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        padding: "20%",
        backgroundColor: "rgba(255,255,255,0.75)"
      },
      alreadyUsedHead: {
        fontSize: 24,
        fontStyle: "initial",
        marginBottom: 10
      },
      cancel: {
        float: "right",
        textAlign: "center"
      },
      smallCancel: {
        float: "initial"
      },
      deleteError: {
        color: "red",
        marginTop: 5
      },
      seat: {
        fontSize: "3em",
        fontWeight: "bold",
        textAlign: "center",
        margin: "2% 0"
      }
    };
  }

  render() {
    var styles = this.getStyles(),
      { ticket } = this.props;

    const display_passes_or_memberships = this.context.tenant.membership_enabled ? this.context.tenant.display_memberships : this.context.tenant.display_passes;
    const display_pass_or_membership = this.context.tenant.membership_enabled ? this.context.tenant.display_membership : this.context.tenant.display_pass;

    return (
      <div>
        <div style={styles.container}>
          {ticket.used_at ? (
            <div style={styles.alreadyUsed}>
              <div style={styles.alreadyUsedHead}>Ticket has been scanned</div>
              {moment(ticket.used_at).format("LLLL")}
            </div>
          ) : null}
          <div style={styles.ticket} />
          {ticket.seat ? <div style={styles.seat}>{ticket.seat}</div> : null}
          <div style={styles.info}>
            {/*ticket.probably_customer_cancellable ? (
              <div style={styles.cancel}>
                {this.context.isLarge ? (
                  <RaisedButton label="Cancel ticket" onClick={this.cancel} />
                ) : (
                  <CogButtonMenu>
                    <MenuItem
                      style={{ cursor: "pointer" }}
                      key="cancel"
                      onClick={this.cancel}
                      primaryText="Cancel ticket"
                    />
                  </CogButtonMenu>
                )}
              </div>
                ) : null*/}
            <div>
              <strong>Ticket:</strong>&nbsp;{ticket.id.toUpperCase()}
            </div>
            <div>
              <strong>Event:</strong> {ticket.event.name}
            </div>
            {ticket.event.custom_id ? (
              <div>
                <strong>Event ID:</strong> {ticket.event.custom_id}
              </div>
            ) : null}
            <div>
              <strong>Type:</strong> {ticket.ticket_bucket.name}
            </div>
            {ticket.pass && (
              <div>
                <strong>{capitalize(display_pass_or_membership)}:</strong>{" "}
                {ticket.pass.name}
              </div>
            )}
            <div>
              <strong>Ordered:</strong>{" "}
              {moment(ticket.created_at).format("LLLL")}
            </div>
          </div>
          {this.context.tenant.ticket_scan_message &&
            <strong>{this.context.tenant.ticket_scan_message}</strong>
          }
        </div>
      </div>
    );
  }
}

export default TicketSlide;



// WEBPACK FOOTER //
// ./src/app/components/partials/ticket-slide.jsx